import "./style.css";
import "./app.js";
import "./sync.js";

/* ホーム画面から起動したときに、電波がなくても開けるようにする。
 * 開発中は sw.js に埋め込み前の目印が残っているので、本番のみ登録する。 */
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  const hadController = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    // 新しい版が入れ替わったときだけ読み直す（初回の登録では読み直さない）
    if (hadController && !window.__inkboardReloading) {
      window.__inkboardReloading = true;
      location.reload();
    }
  });
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("./sw.js").catch(() => {});
  });
}
